import React, { createContext, useState } from "react";
import {Consts} from "./consts";

const VERSION = "1.17";
const DESCRIPTION = "Created 15.04.2026";
const InitContext = createContext();

export const InitProvider = ({ children }) => {
  const [context, setContext] = useState({
    token: sessionStorage?.getItem(Consts.TOKEN) || "",
    role: sessionStorage?.getItem(Consts.ROLE) || "",
    patient: JSON.parse(sessionStorage?.getItem(Consts.PATIENT)) || {},
    patients: JSON.parse(sessionStorage?.getItem(Consts.PATIENTS)) || {},
    userId: parseInt(sessionStorage?.getItem(Consts.USER_ID)) || -1,
    version: VERSION,
    description: DESCRIPTION,
    language: sessionStorage?.getItem(Consts.LANGUAGE) || "en",
    studyBranch: sessionStorage?.getItem(Consts.STUDY_BRANCH) || "Demo-hospital"
  });

  const login = (data) => {
    setContext({
      ...data,
      version: VERSION,
      description: DESCRIPTION,
    });

    sessionStorage?.setItem(Consts.TOKEN, data?.token);
    sessionStorage?.setItem(Consts.ROLE, data?.role);
    sessionStorage?.setItem(Consts.PATIENT, JSON.stringify(data?.patient));
    sessionStorage?.setItem(Consts.PATIENTS, JSON.stringify(data?.patients));
    sessionStorage?.setItem(Consts.USER_ID, data?.userId);
    sessionStorage?.setItem(Consts.LANGUAGE, data?.language);
    sessionStorage?.setItem(Consts.STUDY_BRANCH, data?.studyBranch);
  };

  const logout = () => {
    setContext({
      token: "",
      role: "",
      patient: {},
      patients: {},
      userId: -1,
      version: VERSION,
      description: DESCRIPTION,
      language: "en",
      studyBranch: "Demo-hospital"
    });

    sessionStorage.clear();
  };

  const updateContextPatient = (newPatient) => {
    setContext((prevContext) => ({
      ...prevContext,
      patient: newPatient,
    }));

    sessionStorage.setItem(Consts.PATIENT, JSON.stringify(newPatient));
  };

  return (
    <InitContext.Provider value={{ ...context, login, logout, updateContextPatient }}>
      {children}
    </InitContext.Provider>
  );
};

export default InitContext;
